import { useBooleanState } from "@gettactic/helpers/src";
import { useAuthenticated } from "@gettactic/hooks";
import {
  parseQueryObject,
  useUrlQuerySync
} from "@webV2/hooks/useUrlQuerySync";
import { useRouter } from "next/router";
import React from "react";

export const useMapSelectedOfficeUrlSync = (enabled = true, initialFloorIdParam?: string) => {
  const isLoaded = useBooleanState();

  const {
    userContext: { authenticatedUser, currentOffice },
    setUserContext
  } = useAuthenticated();

  const router = useRouter();

  const [initialFloorId, setInitialFloorId] = React.useState<string | null>(
    initialFloorIdParam ?? null
  );

  useUrlQuerySync(
    {
      officeId: currentOffice.id
    },
    (paramsFromUrl) => {
      // Support old URL format with hash
      const [, hash] = (router.asPath as string).split("#");
      const parsedHash = new URLSearchParams(hash);
      const officeId = parsedHash.get("officeId") || null;

      const urlOfficeId = String(officeId || paramsFromUrl.officeId);

      if (urlOfficeId && urlOfficeId !== currentOffice.id) {
        const office = authenticatedUser.offices?.byId[urlOfficeId];
        if (office) {
          setUserContext({
            type: "updateCurrentOffice",
            payload: office.id
          });
        } else {
          console.warn(`Office with ID ${urlOfficeId} not found.`);
        }
      }
    },
    enabled && router.isReady,
    false,
    true
  );

  React.useEffect(() => {
    // Support old URL format with hash
    const parsed = parseQueryObject(router.query);
    const [, hash] = (router.asPath as string).split("#");
    const parsedHash = new URLSearchParams(hash);
    const officeId = parsedHash.get("officeId") || null;
    const initialFloorId =
      (!Array.isArray(parsed.floorId) ? String(parsed.floorId) : null) ||
      parsedHash.get("floorId") ||
      null;

    setInitialFloorId(initialFloorId);

    if (officeId && officeId !== currentOffice.id) {
      setUserContext({
        type: "updateCurrentOffice",
        payload: officeId || ""
      });
      return;
    }

    isLoaded.true();
  }, [router.isReady, currentOffice.id]);

  return {
    initialFloorId,
    isLoaded: isLoaded.state
  };
};
